import React from 'react'; 
import { Route, Routes } from 'react-router-dom';

import Profile from '../profile/Profile';

const ProfileRoutes = () => {
    return (
        <>
            <Routes>
                <Route path="/view-profile" element={<Profile />} />
            </Routes>
        </>
    )
}

export default ProfileRoutes;